import axios from 'axios';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error?.response?.status || error?.response?.status === 0) {
            // console.log('error', error);
        }
        return Promise.reject(error);
    },
);
